import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import {
  ParentOrganisationCapabilityLoading,
  useParentOrganisationCapabilityBootstrap,
} from './ParentOrganisationCapability';

const AdministrationRootRedirect = ({ path, globalAdministration }) => {
  const {
    currentOrganisation,
    hasParentOrganisationCapability,
  } = useParentOrganisationCapabilityBootstrap(!globalAdministration);

  if (globalAdministration) {
    return <Redirect to={`${path}/organisations`} />;
  }

  if (currentOrganisation.status === 'idle' || currentOrganisation.status === 'loading') {
    return <ParentOrganisationCapabilityLoading />;
  }

  return (
    <Redirect
      to={hasParentOrganisationCapability ? `${path}/child-organisations` : `${path}/organisation`}
    />
  );
};

AdministrationRootRedirect.propTypes = {
  path: PropTypes.string.isRequired,
  globalAdministration: PropTypes.bool.isRequired,
};

export default AdministrationRootRedirect;
